import { WafError } from '../constant/type';
import api from '../../../../../api';
import { populateWafError } from './waf-error-reducer';
import store from '../../../../store';

export function createWafModal(error: WafError) {
  try {
    api.technicalError(error.correlationId, error.url, error.method);
    store.dispatch(populateWafError(error));
  } catch (e) {
    console.log(error);
  }
}
